import { useContext } from "react";

import { UnreadNotificationsCountContext } from "../utils/notifications";

export function useUnreadNotificationsContext() {
  return useContext(UnreadNotificationsCountContext);
}
